enum MessageSides {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

enum MessageDeliveryStatus {
  PENDING = 'pending',
  SENDING = 'sending',
  FAILED = 'failed',
  SENT = 'sent',
}

enum MessageAttachmentType {
  IMAGE = 'image',
  FILE = 'file',
}

enum MessageType {
  TEXT = 'text',
  IMAGE = 'image',
  FILE = 'file',
  EVENT = 'event',
}

enum MessageBorderStyleType {
  START = 'start',
  END = 'end',
  CENTER = 'center',
}

export {
  MessageAttachmentType,
  MessageDeliveryStatus,
  MessageSides,
  MessageType,
  MessageBorderStyleType,
};
